<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'materialArticleEdit',
})
</script>
<template>
  <ArticleForm />
</template>

<script setup lang="ts" name="materialArticleEdit">
import ArticleForm from './form.vue'
</script>
